import { render, staticRenderFns } from "./studentMockList.vue?vue&type=template&id=d96601f4&scoped=true&"
import script from "./studentMockList.vue?vue&type=script&lang=js&"
export * from "./studentMockList.vue?vue&type=script&lang=js&"
import style0 from "./studentMockList.vue?vue&type=style&index=0&id=d96601f4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96601f4",
  null
  
)

export default component.exports